import { useIsDesktop } from '@/hooks/useIsDesktop';
import { DesktopHome } from './desktop/DesktopHome';
import { MobileHome } from './mobile/MobileHome';

/** Learner home — device-branched between the two UXs. */
export function LearnerHome() {
  return useIsDesktop() ? <DesktopHome /> : <MobileHome />;
}
